const shopname = 'epoque'
// const shopname = 'map'

let version = 'shengchang'
if(/-test/.test(document.URL)){
  version = 'ceshi'
}
// const version = 'ceshi'
// const version = 'shengchang'

const config = () => {
  if(version == 'ceshi'){
    return {
      domainname: 'http://custom-mall-test.epoque.cn',
      router: 'http://custom-mall-api-test.epoque.cn',
      vouchernoApi: 'http://119.23.59.31:8091/',
      routerapi: 'http://custom-mall-api-test.epoque.cn/v1/wechat/oauth/entrance',
      version,
      shopname,
      parturl:'http://test.epoque.cn/copemate'
    }
  }
  return {
    domainname: 'http://custom-mall.epoque.cn',
    router: 'http://custom-mall-api.epoque.cn',
    vouchernoApi: 'http://office.epoque.cn/api-v1.0/',
    routerapi: 'http://custom-mall-api.epoque.cn/v1/wechat/oauth/entrance',
    version,
    shopname,
    parturl:'http://custom-partner-api.epoque.cn'
  }
}

export default config()



// WEBPACK FOOTER //
// ./src/conf/index.js